import { InstagramEmbed } from "react-social-media-embed";
import * as S from "./Instagram.styles";
import { Button } from "../../components/Button/Button";
import { CiInstagram } from "react-icons/ci";
import { SubTitleText } from "../../components/SubTitleText/SubTitleText";

export const Instagram = () => {
  return (
    <S.InstagramWrapper id="social">
      <SubTitleText text="Redes sociais" />
      <S.PostsWrapper>
        <InstagramEmbed
          url="https://www.instagram.com/p/DKupdlWxXnC"
          width={316}
        />
        <InstagramEmbed
          url="https://www.instagram.com/p/DK92QhXM5TQ"
          width={316}
        />
        <InstagramEmbed
          url="https://www.instagram.com/p/DNV_BKTuJjx"
          width={316}
        />
      </S.PostsWrapper>
      <S.ButtonWrapper>
        <Button
          text="Instagram"
          icon={<CiInstagram />}
          size="18px"
          href={"https://www.instagram.com/psi.aureagomes/"}
        />
      </S.ButtonWrapper>
    </S.InstagramWrapper>
  );
};
